// The access token lives in memory only (never in storage, where an injected script could read it). The refresh
// token is an httpOnly cookie the browser sends to /api/v1/auth by itself.

export interface Session {
  accessToken: string;
  expiresAt: number; // ms since epoch
  accountId: string;
  role: string;
}

type Listener = (s: Session | null) => void;

let current: Session | null = null;
const listeners = new Set<Listener>();

export const sessionStore = {
  get: (): Session | null => current,
  set(next: Session | null): void {
    current = next;
    listeners.forEach((l) => l(next));
  },
  subscribe(l: Listener): () => void {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};

export interface AccessTokenOut { accessToken: string; expiresAt: string; accountId: string; role: string }

export function sessionFrom(t: AccessTokenOut): Session {
  return { accessToken: t.accessToken, expiresAt: Date.parse(t.expiresAt), accountId: t.accountId, role: t.role };
}
